import { Permission, Res, TicketDTO } from 'core/api';
import { SessionProvider } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';


export async function ticketCanBePrintedUnderMinRequiredAmount(ticket: TicketDTO): Promise<boolean> {
	if (ticket.NetAmount < ticket.MinRequiredAmount && !SessionProvider.hasPermission(Permission.Ticket_PrintProformUnderMinRequiredAmount)) {
		await Message.show(Res.Msg.MSG_CANNOT_PRINT_PROFORM_BECAUSE_OF_MIN_REQUIRED_AMOUNT(ticket.NetAmount, ticket.MinRequiredAmount));
		return false;
	}
	return true;
}